<script>
  import { useNavigate } from "svelte-navigator";
  import { onMount } from "svelte";
  import VideoPreviewOverlay from "./overlays/VideoPreviewOverlay.svelte";
  // import VideoEditOverlay from "./overlays/VideoEditOverlay.svelte";
  import { videoDetailStore } from "../stores/Video";
  // import videoUploadStore from "../stores/Video/videoUpload";
  import {
    headerDisplayStore,
    dialogStore,
    loadingStore,
  } from "../stores/General";
  import { getList, remove } from "../api";
  import RouteButton from "../components/button/RouteButton.svelte";
  import GenericButton from "../components/button/GenericButton.svelte";
  import UploadBulk from "./overlays/UploadBulk.svelte";
  import { dateShort } from "../utils/conv";
  import { languages } from "../assets/GeoData";
  import Table from "../components/table/Table.svelte";

  const navigate = useNavigate();
  const module_name = "topper";
  const masking = {
    mask: "-",
    values: ["0", null, 0, undefined, ""],
  };
  let videoPreviewUrl;
  let videoPreviewPosterUrl;
  let BulkFormOpen = false;
  let totalCurrentFileCount = 0;
  let selectedIds = [];
  // let width = 150;
  const tableId = "toppers";

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  let filters = [
    {
      label: "Search by",
      key: "title",
      filter: "text",
      value: "",
      options: [
        { value: "title", label: "Asset Name" },
        { value: "description", label: "Description" },
        { value: "original_filename", label: "Video File" },
        { value: "series", label: "Asset series"},
        { value: "keyword_id", label: "Tags"},
        { value: "iab_categories", label: "IAB Value/Name"},
      ],
    },
    {
      label: "Select Product Category",
      key: "product_category",
      filter: "combo",
      multi: true,
      clearable: false,
      value: "",
      options:[
        {value: "Ad Studio", label: "Ad Studio"},
        {value: "Open", label: "Open"},
        {value: "Instant", label: "Instant"},
        {value: "Instant+", label: "Instant+"},
        {value: "Prime", label: "Prime"},
        {value: "Slate", label: "Slate"}
      ],
    },
    {
      label: "Select Asset Type",
      key: "asset_type",
      filter: "combo",
      multi: true,
      clearable: false,
      value: "",
      options:[
        {value: "Brand Ad", label: "Brand Ad"},
        {value: "Stitched Ad", label: "Stitched Ad"},
        {value: "Topper", label: "Topper"},
        {value: "Chaser", label: "Chaser"},
        {value: "BookendOpen", label: "BookendOpen"},
        {value: "BookendClose", label: "BookendClose"},
      ],
    },
  ];

  let filter = {};

  onMount(() => {
    headerDisplayStore.SetTitle("Studio");
    headerDisplayStore.SetBreadCrumbs([
      {
        key: "video",
        label: "Video",
      },
      {
        key: "list",
        label: "List",
      },
    ]);
    const urlFilter = getParameterByName("filter");
    if (urlFilter) {
      try {
        filter = JSON.parse(urlFilter);
        filters.forEach((f) => {
          f.value = filter[f.key] || "";
        });
        filters = filters;
      } catch {
        //
      }
    }
    loadData();
  });

  function openDetail(value) {
    let item = data.find((dataItem) => {
      return dataItem.topper_id === value.topper_id;
    });
    if (totalCurrentFileCount == 0) {
      videoDetailStore.set(item || {});
      navigate("/studio/detail");
    }
  }

  function editAction(value) {
    navigate(`/studio/edit/${value.topper_id}`);
  }

  function openBulkForm() {
    BulkFormOpen = true;
  }

  function previewAction(value) {
    videoPreviewPosterUrl = value.thumbnail_url;
    videoPreviewUrl = value.asset_url;
  }


  function onActionClick({ detail }) {
    const { action, row } = detail;

    switch (action.key) {
      case "edit":
        editAction(row);
        break;
      case "preview":
        previewAction(row);
        break;
      case "dlt":
        deleteAction(row);
        break;
    }
  }

  const columns = [
    // {
    //   label: "ID",
    //   dataKey: "topper_id",
    //   renderBy: "formatter",
    //   // isClickable: true,
    // },
    {
      label: "Thumbnail",
      dataKey: "thumbnail_url",
      renderBy: "image",
      isHidden: true,
    },
    {
      label: "Product Category",
      dataKey: "product_category",
      sortBy: "product_category",
      renderBy: "formatter",
    },
    {
      label: "Asset Series",
      dataKey: "series",
      sortBy: "series_text",
      renderBy: "formatter",
      masking,
      formatter: (val) => {
        if (val?.length) {
          return val.map((v) => v.series_id).join(", ");
        }
        return;
      },
    },
    {
      label: "Asset Type",
      dataKey: "asset_type",
      sortBy: "asset_type",
      renderBy: "formatter",
    },
    {
      label: "Asset Name",
      dataKey: "title",
      sortBy: "title",
      width: "180",
      renderBy: "formatter",
      // isClickable: true,
    },
    {
      label: "Video File",
      dataKey: "original_filename",
      renderBy: "formatter",
      // isClickable: true
    },
    {
      label: "Description",
      dataKey: "description",
      renderBy: "formatter",
      isHidden: true,
    },
    {
      label: "Tags",
      dataKey: "keywords",
      masking,
      sortBy: "keywords_text",
      renderBy: "formatter",
      // isClickable: true,
      formatter: (val) => {
        if (val?.length) {
          return val.map((v) => v.keyword_id).join(", ");
        }
        return;
      },
    },
    {
      label: "IAB Value",
      dataKey: "iab_categories",
      renderBy: "formatter",
      masking,
      sortBy: "iab_categories_text",
      formatter: (val) => {
        if (val?.length) {
          return val.map((v) => v.iab_category_id).join(", ");
        }
        return;
      },
    },
    {
      label: "IAB Tier 1",
      dataKey: "iab_top_tier",
      sortBy: "iab_top_tier",
      renderBy: "formatter",
      isHidden: false,
    },
    {
      label: "IAB Tier 2",
      dataKey: "iab_tier",
      sortBy: "iab_tier",
      renderBy: "formatter",
      isHidden: false,
    },
    {
      label: "Language",
      dataKey: "language",
      renderBy: "formatter",
      formatter: (val) => {
        if (val?.length) {
          const lang = languages.filter((l) => l.value == val);
          return lang[0]?.label || val;
        }
        return;
      },
    },
    {
      label: "Duration",
      dataKey: "duration",
      renderBy: "formatter",
      formatter: (val) => {
        if (val) {
          const rounded = Math.round(val);
          const durationFormat =
            rounded > 60
              ? `${Math.floor(rounded / 60)}:${rounded % 60} min`
              : `${val.toFixed(2)} sec`;
          return durationFormat;
        }
        return;
      },
    },
    {
      label: "Creator",
      dataKey: "creator",
      sortBy: "creator",
      renderBy: "formatter",
      masking,
    },
    {
      label: "Record Created Date",
      dataKey: "created_at",
      sortBy: "created_at",
      renderBy: "formatter",
      formatter: dateShort,
      masking,
    },
    {
      label: "Asset Modified Date",
      dataKey: "update_at",
      sortBy: "update_at",
      renderBy: "formatter",
      formatter: dateShort,
      masking,
    },
    {
      label: "Servable Start Date",
      dataKey: "start_date",
      sortBy: "start_date",
      renderBy: "formatter",
      formatter: dateShort,
      masking,
    },
    {
      label: "Servable End Date",
      dataKey: "end_date",
      sortBy: "end_date",
      renderBy: "formatter",
      formatter: dateShort,
      masking,
    },
    {
      renderBy: "actions",
      actions: [
        {
          key: "edit",
          label: "Edit",
          icon: "edit",
        },
        {
          key: "dlt",
          label: "Delete",
          icon: "dlt",
        },
        {
          key: "preview",
          label: "Preview",
          icon: "preview",
        },
      ],
    },
  ];
  let pageSize = 10;
  let data = [];
  let count = 0;
  let page = 1;
  let sortBy = "created_at";
  let sortOrder = "DESC";
  let pagination = { page, pageSize, count };

  function loadData() {
    let mainSettingsArray = JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

    pagination = {...pagination, ...mainSettingsArray?.pagination};

    if (pagination !== null){
      pageSize = pagination.pageSize;
      page = pagination.page;
    }

    data = [];
    loadingStore.on(module_name);
    getList(module_name, pageSize, page, sortBy, sortOrder, filter)
      .then((response) => {
        loadingStore.off(module_name);
        data = response.data;
        pagination.count = response.count;
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }

  function onPageChange(event) {
    let mainSettingsArray= JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

      mainSettingsArray ={...mainSettingsArray, pagination:event.detail};

      localStorage.setItem(
      `_tableMainSettings_${tableId}`,
      JSON.stringify(mainSettingsArray)
    );

    page = event.detail.page;
    pageSize = event.detail.pageSize;
    loadData();
  }

  function onSortChange(event) {
    sortBy = event.detail.sortBy;
    sortOrder = event.detail.sortOrder;
    loadData();
  }

  function onFilterChange(event) {
    let eventFilter = event.detail.filter;
    
    for (let key in eventFilter) {

    if (eventFilter[key].length === 0) {
      delete eventFilter[key];
    }
  }

  filter = eventFilter;
    
  page = 1;
  loadData();
  }
  
  function onCheckedChange(event) {
    selectedIds = event.detail.selectedIds;
  }
  function deleteSelected() {
    const selectedRows = data.filter((item) =>
      selectedIds.includes(item.topper_id)
    );
    dialogStore.openDeletePrompt(module_name, selectedRows, () => {
      selectedIds = [];
      loadData();
    });
  }
  function deleteAction(value) {
    dialogStore.openDeletePrompt(module_name, [value], () => {
      selectedIds = [];
      loadData();
    });
  }
</script>

<div class="flex flex-col h-full">
  <div class="w-full sm:px-6">
    <div class="py-2 md:py-2">
      <div class="sm:flex items-center justify-between">
        <div />
        <div>
          <div
            class="flex justify-center z-0 shadow-sm rounded-md sm:shadow-none sm:space-x-6"
          >
            <RouteButton name="New Asset" route="/studio/new" />
            <GenericButton
              height="2.5rem"
              width="12rem"
              text="Bulk Upload"
              buttonIcon={{ name: "image_upload" }}
              onClick={openBulkForm}
            />
          </div>
        </div>
      </div>
    </div>
    <Table
      bind:data
      {columns}
      {filters}
      dataKey="topper_id"
      loader={$loadingStore.loading}
      {pagination}
      sorting={{ sortBy, sortOrder }}
      {selectedIds}
      defaultConfig={{
        tableId,
        stickyHeader: true,
        stickyFirstColumn: true,
        stickyLastColumn: true,
        multilineColumns: true,
        showCheckboxes: true,
        enableDeleteAll: true,
      }}
      on:delete={deleteSelected}
      on:checkedChange={onCheckedChange}
      on:pageChange={onPageChange}
      on:sortChange={onSortChange}
      on:filterChange={onFilterChange}
      on:actionClick={onActionClick}
      on:sortClick={onSortChange}
    />
    <!-- isUploading ={totalCurrentFileCount == 0 ? false:true} -->
  </div>
  {#if videoPreviewUrl}
    <VideoPreviewOverlay
      source={videoPreviewUrl}
      poster={videoPreviewPosterUrl}
      onClose={() => {
        videoPreviewUrl = null;
      }}
    />
  {/if}
  {#if BulkFormOpen}
    <UploadBulk
      bind:showModal={BulkFormOpen}
      onClose={() => {
        loadData();
      }}
    />
  {/if}
</div>
